import { Observable } from 'rxjs';
import { searchCompleted, SEARCH_REQUESTED } from '../redux/search';
import { PACKAGES_FETCH_SUCCEEDED } from '../redux/packages';
import Router from 'next/router';
import { combineEpics } from 'redux-observable';
import { buildCardsUrl } from '../utils/urls/urlGenerator';

import type { ActionObs, Obs, PackagesFetchSucceeded } from '../types';

export function searchRequestedEpic(action$: ActionObs, store: Store): Obs {
  return action$
    .ofType(SEARCH_REQUESTED)
    .switchMap(({ payload: { category, query } }) => {
      const state = store.getState();
      const { isMobile } = state.env;
      const url = buildCardsUrl(category, query);
      Router.push(url, url, { shallow: true });
      return Observable.empty();
    });
}

export function searchCompletedEpic(action$: ActionObs, store: Store): Obs {
  return action$
    .ofType(PACKAGES_FETCH_SUCCEEDED)
    .switchMap((action: PackagesFetchSucceeded) => {
      const { query, total, pagination } = action.payload;

      const obs = query
        ? Observable.of(searchCompleted(query, total, pagination.currentPage))
        : Observable.empty();
      return obs;
    });
}

export default combineEpics(searchRequestedEpic, searchCompletedEpic);
